import styled from 'styled-components';
import { VisuallyHidden } from '../../ui-components/utils.styles';

export const Heading = styled.h1`
    ${VisuallyHidden}
`;
